export const LIWAT_GOOGLE_CLIENT_ID =
    "57317220877-tv3omg941lo02ufrpv4g3omcd1iuokl0.apps.googleusercontent.com";
